/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetCommentsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {BatchGetCommentsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const batchGetComments = (request: BatchGetCommentsRequest, options?: CashRequestOptions) => post<BatchGetCommentsRequest, BatchGetCommentsResponse>("/2.0/cash/batch-get-comments", request, {...options, rejectOnError: true })